import { AppNode, NodeType } from "@features/builder/graph/types"
import { DecodedNodeUnit, decodeNodeUnit } from "@utils/format/nodeUnitFormat"
import { BulkNodesEditFormValues } from "@features/builder/BulkNodesEditDialog/BulkNodesEditForm/BulkNodesEditForm"
import { splitLagNodeLabel } from "@utils/node/labelValidation"
import logger from "@utils/logger"
import { isPseudoNodeType, isTaggableNodeType } from "@features/builder/helpers/nodes"
import { groupGraphTagsByName } from "@features/builder/NodeDrawer/NodeForm/helpers"

export const getDefaultValues = (nodes: AppNode[]): BulkNodesEditFormValues => {
  return {
    nodes: Object.fromEntries(
      nodes.map((node) => {
        let link = ""
        let label = node.data.label ?? ""
        let lagValue: number | null = null
        if (node.type === NodeType.Lag) {
          const lagParts = splitLagNodeLabel(node.data.label)
          label = lagParts.label
          lagValue = lagParts.lagValue
        }

        let historicMnemonic = ""
        let scenarioMnemonic = ""
        let forecastMnemonic = ""
        if ("metaNode" in node.data) {
          historicMnemonic = node.data.metaNode["Historic Mnem"] ?? ""
          scenarioMnemonic = node.data.metaNode["Scenario Mnem"] ?? ""
          forecastMnemonic = node.data.metaNode["Forecast Mnem"] ?? ""
        }

        let decimalPlaces = ""
        let showAsPercentage = false
        let suffix = ""
        let tags: BulkNodesEditFormValues["nodes"][string]["tags"] = []
        let graphTags: BulkNodesEditFormValues["nodes"][string]["graphTags"] = []

        if (node.type !== NodeType.Group) {
          link = !isPseudoNodeType(node.type) ? node.data.metaNode.Link ?? "" : ""

          if (isTaggableNodeType(node.type)) {
            tags = (node.data.metaNode.tags ?? []).map((tag) => ({
              tag: tag.Name,
              value: tag.Value,
            }))
            graphTags = groupGraphTagsByName(node.data.metaNode.graph_tags ?? [])
          }

          let decodedUnit: DecodedNodeUnit = {
            isEmpty: true,
            decimalPlaces: "",
            usePercentageValue: false,
            suffix: "",
          }
          const unit = node.data.metaNode["Unit Format"] ?? ""
          try {
            decodedUnit = decodeNodeUnit(unit)
          } catch (error) {
            logger.error(`Failed to decode node unit "${unit}"`, { error, nodeId: node.id })
          }

          if (!decodedUnit.isEmpty) {
            decimalPlaces = decodedUnit.decimalPlaces
            showAsPercentage = decodedUnit.usePercentageValue
            suffix = decodedUnit.suffix ?? ""
          }
        }

        return [
          node.id,
          {
            id: node.id,
            label,
            lagValue,
            link,
            isSelected: true,
            historicMnemonic,
            scenarioMnemonic,
            forecastMnemonic,
            unitDecimalPlaces: decimalPlaces,
            unitShowAsPercentage: showAsPercentage,
            unitSuffix: suffix,
            tags,
            graphTags,
          },
        ]
      }),
    ),
  }
}
